'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var colorOpacity_util = require('./color-opacity.util-b6f07f55.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index$1 = require('./index-c3c373ce.js');
var checkboxHqo = require('./checkbox-hqo-12533261.js');

var StyledCheckbox = styled__default(checkboxHqo.CheckboxHqo)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  align-self: flex-start;\n  padding: 0;\n"], ["\n  align-self: flex-start;\n  padding: 0;\n"])));
var IconContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-right: 7px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 7px;\n"])));
var StyledText = styled__default.p(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 14px/22px ", ";\n  font-style: normal;\n  font-weight: normal;\n  align-self: flex-start;\n  margin: 0;\n"], ["\n  font: 14px/22px ", ";\n  font-style: normal;\n  font-weight: normal;\n  align-self: flex-start;\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.fonts.join());
});
var StyledMenuItem = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  min-height: 38px;\n  padding: 8px 16px;\n  margin-bottom: 8px;\n  width: 100%;\n  overflow: hidden;\n  font: 14px ", ";\n  font-weight: normal;\n  font-style: normal;\n  line-height: 22px;\n  background-color: ", ";\n  ", "\n\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  &.focused {\n    background-color: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  min-height: 38px;\n  padding: 8px 16px;\n  margin-bottom: 8px;\n  width: 100%;\n  overflow: hidden;\n  font: 14px ", ";\n  font-weight: normal;\n  font-style: normal;\n  line-height: 22px;\n  background-color: ", ";\n  ", "\n\n  &:hover {\n    cursor: pointer;\n    background-color: ",
    ";\n  }\n\n  &.focused {\n    background-color: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.fonts.join());
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected && theme.colorsRgba.primary_1;
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly && 'cursor: not-allowed;';
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return (selected && theme.colorsRgba.primary_1)
        || theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return colorOpacity_util.rrggbbaa(theme.colors.floorPlan.blue, 0.1);
});
var MenuItem = function (_a) {
    var _b;
    var storedValue = _a.storedValue, label = _a.label, value = _a.value, icon = _a.icon, onChange = _a.onChange, isSelected = _a.isSelected, showCheckBox = _a.showCheckBox, readOnly = _a.readOnly;
    var itemClassName = ("item-" + value).replace(' ', '-');
    var menuItemClassName = index$1.classnames('menu-item', (_b = {
            'read-only': readOnly,
            selected: isSelected
        },
        _b[itemClassName] = value,
        _b));
    var handleMenuItemClick = React.useCallback(function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (onChange && !readOnly) {
            onChange(storedValue, !isSelected);
        }
    }, [isSelected, onChange, readOnly, storedValue]);
    return (React__default.createElement(StyledMenuItem, { selected: isSelected, className: menuItemClassName, "data-cy": label + "-Menu-Item", "data-testid": label + "-Menu-Item", key: label + "-Menu-Item", onClick: handleMenuItemClick, readOnly: readOnly },
        showCheckBox && (React__default.createElement(StyledCheckbox, { "data-cy": label + "-Menu-Item-Checkbox", "data-testid": label + "-Menu-Item-Checkbox", checked: isSelected, disabled: readOnly })),
        icon && React__default.createElement(IconContainer, null, icon),
        React__default.createElement(StyledText, { className: itemClassName }, label)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.MenuItem = MenuItem;
